import { render, staticRenderFns } from "./SubjectDialog.vue?vue&type=template&id=276a4fc2"
import script from "./SubjectDialog.vue?vue&type=script&lang=js"
export * from "./SubjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports